import React, { useContext } from 'react';
import { UploadStateContext } from '@/components/upload-core/context';
import { UploadListItem } from './upload-list-item';
export const UploadList = (props) => {
    const { value } = useContext(UploadStateContext);
    if (!value?.length)
        return null;
    return (React.createElement(React.Fragment, null, value.map((item, index) => (React.createElement(UploadListItem, { key: item.key || item.name || item.size, index: index, style: props.style, file: item })))));
};
